<template>
  <component
    v-if="routeComponent"
    :is="routeComponent"
    :key="routeKey"
    v-bind="routeProps"
    @roleId="$emit('roleId', $event)"
  />
</template>

<script>
import { markRaw } from 'vue'
import router from '@/router'

export default {
  name: 'RouteRenderer',
  emits: ['roleId', 'routeChanged'],
  data () {
    return {
      routeComponent: null,
      routeKey: '',
      routeProps: {}
    }
  },
  created () {
    this.renderRoute(router.currentRoute.value)
    this.removeAfterEach = router.afterEach((route) => this.renderRoute(route))
  },
  beforeUnmount () {
    if (this.removeAfterEach) {
      this.removeAfterEach()
    }
  },
  methods: {
    renderRoute (route) {
      const record = route.matched[route.matched.length - 1]
      const component = record && record.components && record.components.default
      const propsOption = record && record.props && record.props.default

      this.routeComponent = component ? markRaw(component) : null
      this.routeProps = typeof propsOption === 'function'
        ? propsOption(route)
        : (propsOption || {})
      this.routeKey = route.fullPath
      this.$emit('routeChanged', route)
    }
  }
}
</script>
